import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '500万优惠券来了！京东联合上游新闻联合发起重庆“五一宅家大扫除”';

const route: RouteConfig = {
  path: '/20200427YHQ',
  name: 'YHQ',
  component: () => import('./Home.vue'),

  meta: {
    title: PAGE_TITLE,
  },
};

export default route;
